import styled from "styled-components";

const DriversWrapper = styled.div`
.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
    display:none
        }
        
.otherInfoTitle{
            font-weight:800;
            font-size:20px;
        }
.otherInfoSubTitle{
            font-weight:800;
            font-size:1rem;
        }
.p-accordion-header-text {
    width:100%;
    font-weight:800;
    font-size:20px;
}
.radioTitle{
    font-weight:400;
    font-size:16; 
}
.headerText{
    font-weight: 800;
font-size: 1.2rem;
line-height: 120%;
letter-spacing:-0.01em;
    padding-bottom: 35px;
}
.headerText-rtl{
    padding-left: 0% !important;
}
.IconDiv{
    padding-left: 11% !important;
}
.IconDiv-rtl{
    padding-left: 0% !important;
}
.accordianIcon{
   color:#6B47F5
}
.personal{padding:40px;text-align:left;}
.persona-det {
    background: #fff;padding: 24px;box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);border-radius: 12px;
    .persona-head {
        h2{font-weight: 800;font-size: 1.3rem;color: #4C565C;}
        p{font-weight: 400;font-size:1rem;color: #4C565C;}
        
    }
    .personal-form {
        background: #F2F3F5;border-bottom: 2px solid #F2F3F5;border-radius: 8px;padding: 24px;
            .nationalid {
                margin: 20px 0;
                input.p-inputtext.p-component {padding: 15px 70px;border: none;width: 100%;background: #FFFFFF;box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);border-radius: 4px;}
            }
        .telep {
           margin:20px 0;
            .telephone {
                background: #F2F3F5;border-radius: 8px;width: 100%;display: flex;box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);
                .flag {width: 25%;display:flex;
                    i.pi.pi-flag {margin: 20px 15px;}
                    .p-dropdown {background: none;border: none;}
                    .p-dropdown:not(.p-disabled).p-focus {box-shadow: none;}
                    img {width: 23px;height: 15px;margin-top: 17px;margin-left: 16px;}
                }
               
                input.p-inputtext.p-component {width: 100%;border: none;}
            }
        
        }
        .trans {
            margin-top: -6px;
            .field-radiobutton {
                width: max-content;display: inline-block;margin: 0 20px 0 0;
                label {margin-left: 10px;}
                .p-radiobutton .p-radiobutton-box {border: 2px solid #D9DCE1;border-radius: 50%;background: #D9DCE1;}
                .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {border-color: #6B47F5;}
                .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {border-color: #6B47F5;background: #6B47F5;color: #ffffff;}
                .p-radiobutton .p-radiobutton-box.p-highlight {border-color: #6B47F5;background: #6B47F5;}
            }
            .field-radiobutton-group {
               
                label {margin-left: 10px;}
                .p-radiobutton .p-radiobutton-box {border: 2px solid #D9DCE1;border-radius: 50%;background: #D9DCE1;}
                .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {border-color: #6B47F5;}
                .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {border-color: #6B47F5;background: #6B47F5;color: #ffffff;}
                .p-radiobutton .p-radiobutton-box.p-highlight {border-color: #6B47F5;background: #6B47F5;}
            }
        }
        .commercial {
            margin: 20px 0;                           
                input.p-inputtext.p-component {padding: 15px 70px;border: none;width: 100%;background: #FFFFFF;box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);border-radius: 4px;}      
        }
        .clearance {font-weight: 400;font-size:0.8rem;text-align: center;color: #4C565C;}
}
.p-float-label label {
    position: initial;

}
.p-float-label {
    background: white;
}
.mybtn {
    width: 101px;
    height: 54px;
    margin-left: -113px;
}
.mydiv {
    background: white;
    width: 391px;
    height: 54px;
}
.transmission {
    width: 391px;
    height: 54px;
    margin-left: -12px;
    margin-top: 23px;
}
.relation {
    width: 94%;
    height: 54px;
    margin-left: -12px;
    margin-top: 23px;
}
.myradio {
    margin-left: -40px; 
}

}
@media only screen and (max-width: 600px) {
    .IconDiv{
        padding-left: 2% !important;
    }
    .headerText {
        padding-bottom: 35px;
        padding-left: 7%;
    }
    }

@media only screen and (max-width: 575.99px) {   
    .personal{padding:0 10px;
        .persona-det {
            background: #F2F3F5;margin-top: 40px;padding: 10px;box-shadow: none;border-radius: 12px;
        .personal-form {padding: 0px;
            .flag {width: 40% !important;}
        }
        .persona-det .personal-form .telep .telephone .flag i.pi.pi-flag {margin: 20px 10px;}
        .p-dropdown .p-dropdown-label.p-placeholder {padding: 17px 0;display: none;}
        .p-dropdown .p-dropdown-label {display: none;}
        .p-dropdown .p-dropdown-trigger {width: 2rem;}
    
    }
    .p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
display:none
    }
}


`;

export default DriversWrapper;
